"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5129],{

/***/ 83677:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Decco = __webpack_require__(78219);
var Fetch = __webpack_require__(84403);
var Js_json = __webpack_require__(85688);
var Belt_Array = __webpack_require__(2971);
var Caml_option = __webpack_require__(57175);
var STEM__Backend$SmartcutsMacros = __webpack_require__(28284);
var STEM__Interfaces$SmartcutsMacros = __webpack_require__(32985);
function t_encode(v) {
    return [
        "STEM",
        STEM__Interfaces$SmartcutsMacros.signal_encode(v._0),
        Decco.arrayToJson(STEM__Interfaces$SmartcutsMacros.filter_encode, v._1)
    ];
}
function t_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "STEM") {
        if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
        }
        var match$1 = STEM__Interfaces$SmartcutsMacros.signal_decode(Belt_Array.getExn(jsonArr$1, 1));
        var match$2 = Decco.arrayFromJson(STEM__Interfaces$SmartcutsMacros.filter_decode, Belt_Array.getExn(jsonArr$1, 2));
        if (match$1.TAG === /* Ok */ 0) {
            if (match$2.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: /* STEM */ {
                        _0: match$1._0,
                        _1: match$2._0
                    }
                };
            }
            var e = match$2._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: "[1]" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = match$1._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: "[0]" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
var Signal = {
    t_encode: t_encode,
    t_decode: t_decode
};
function t_encode$1(v) {
    return [
        "STEM",
        STEM__Interfaces$SmartcutsMacros.output_encode(v._0)
    ];
}
function t_decode$1(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "STEM") {
        if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
        }
        var v0 = STEM__Interfaces$SmartcutsMacros.output_decode(Belt_Array.getExn(jsonArr$1, 1));
        if (v0.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: /* STEM */ {
                    _0: v0._0
                }
            };
        }
        var e = v0._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: "[0]" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function fromSignal(signal) {
    return /* STEM */ {
        _0: STEM__Backend$SmartcutsMacros.output(STEM__Backend$SmartcutsMacros.applyFilters(STEM__Backend$SmartcutsMacros.fromSignal(signal._0), signal._1))
    };
}
var DataOutput = {
    t_encode: t_encode$1,
    t_decode: t_decode$1,
    fromSignal: fromSignal
};
function request(signal) {
    var payload = JSON.stringify(t_encode(signal));
    return fetch("https://trysmartcuts.com" + "/api/data_extraction/", Fetch.RequestInit.make(/* Post */ 2, undefined, Caml_option.some(payload), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)(undefined)).then(function(prim) {
        return prim.json();
    }).then(function(json) {
        return Promise.resolve(t_decode$1(json));
    });
}
var WebApi = {
    Signal: Signal,
    DataOutput: DataOutput,
    request: request
};
var schemaVersion = "0.1.0";
var DataRegion;
var DataRecord;
var DataRecordsAndSchema;
var ExportToTable;
exports.schemaVersion = schemaVersion;
exports.WebApi = WebApi;
exports.DataRegion = DataRegion;
exports.DataRecord = DataRecord;
exports.DataRecordsAndSchema = DataRecordsAndSchema;
exports.ExportToTable = ExportToTable; /* STEM__Backend-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 28284:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var List = __webpack_require__(68724);
var $$Array = __webpack_require__(53209);
var Curry = __webpack_require__(41386);
var Belt_Map = __webpack_require__(26810);
var Caml_obj = __webpack_require__(14923);
var Belt_List = __webpack_require__(11332);
var Belt_Array = __webpack_require__(2971);
var Caml_array = __webpack_require__(11748);
var Caml_option = __webpack_require__(57175);
var Belt_MapString = __webpack_require__(35082);
var ArrayUtils$SmartcutsMacros = __webpack_require__(6114);
var SuffixTree$SmartcutsMacros = __webpack_require__(28314);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var STEM__Interfaces$SmartcutsMacros = __webpack_require__(32985);
function setIsFilteredBy(item, isFilteredBy) {
    item.isFilteredBy = isFilteredBy;
}
function getSuffixTreeNode(param) {
    return param.suffixTreeNode;
}
function getIsFilteredBy(param) {
    return param.isFilteredBy;
}
function isValid(param) {
    var isFilteredBy = param.isFilteredBy;
    return isFilteredBy === undefined;
}
function size(patterns) {
    return patterns.length;
}
function fromSuffixTree(suffixTree) {
    return Belt_Array.map(SuffixTree$SmartcutsMacros.allNodePaths(suffixTree), function(nodePath) {
        var substring = SuffixTree$SmartcutsMacros.NodePath.collectSubstring(nodePath);
        var suffixTreeNode = SuffixTree$SmartcutsMacros.NodePath.bottom(nodePath);
        return [
            substring,
            {
                suffixTreeNode: suffixTreeNode,
                isFilteredBy: undefined
            }
        ];
    });
}
function toArrayOfArrayOfPrintableTagPaths($$this, htmlTagPathIdentifierByEncodedHtmlTagPathIdentifier, htmlTagPathByHtmlTagPathIdentifier) {
    return Belt_Array.map(Belt_Array.map($$this, function(param) {
        return STEM__Interfaces$SmartcutsMacros.EncodedHtmlTagPathIdentifierSequence.decodeToHtmlTagPathIdentifierSequence(STEM__Interfaces$SmartcutsMacros.EncodedHtmlTagPathIdentifierSequence.fromText(param[0]), htmlTagPathIdentifierByEncodedHtmlTagPathIdentifier);
    }), function(htpiSeq) {
        return Belt_Array.map(htpiSeq, function(htpi) {
            return Belt_Map.getExn(htmlTagPathByHtmlTagPathIdentifier, htpi).tags.join("/");
        });
    });
}
function findBySubstring($$this, substring) {
    return List.assoc_opt(substring, $$Array.to_list($$this));
}
function forEachValidDataRecordPatterns(dataRecordPatterns, f) {
    return Belt_Array.forEach(dataRecordPatterns, function(param) {
        var dataRecordPattern = param[1];
        if (isValid(dataRecordPattern)) {
            return Curry._2(f, param[0], dataRecordPattern);
        }
    });
}
function mapValidDataRecordPatterns(dataRecordPatterns, f) {
    return Belt_Array.keepMap(dataRecordPatterns, function(param) {
        var dataRecordPattern = param[1];
        if (isValid(dataRecordPattern)) {
            return Caml_option.some(Curry._2(f, param[0], dataRecordPattern));
        }
    });
}
function reduceValidDataRecordPatterns(dataRecordPatterns, initResult, f) {
    return Belt_Array.reduce(dataRecordPatterns, initResult, function(result, param) {
        var dataRecordPattern = param[1];
        if (isValid(dataRecordPattern)) {
            return Curry._3(f, result, param[0], dataRecordPattern);
        } else {
            return result;
        }
    });
}
var DataRecordPatterns_DataRecordPattern = {
    getSuffixTreeNode: getSuffixTreeNode,
    getIsFilteredBy: getIsFilteredBy,
    setIsFilteredBy: setIsFilteredBy,
    isValid: isValid
};
var DataRecordPatterns = {
    DataRecordPattern: DataRecordPatterns_DataRecordPattern,
    size: size,
    fromSuffixTree: fromSuffixTree,
    toArrayOfArrayOfPrintableTagPaths: toArrayOfArrayOfPrintableTagPaths,
    findBySubstring: findBySubstring,
    forEachValidDataRecordPatterns: forEachValidDataRecordPatterns,
    mapValidDataRecordPatterns: mapValidDataRecordPatterns,
    reduceValidDataRecordPatterns: reduceValidDataRecordPatterns
};
function fromSignal(signal) {
    var encodedWebPageSequenceString = signal.encodedWebPageSequenceString;
    var suffixTree = SuffixTree$SmartcutsMacros.makeWithText(encodedWebPageSequenceString);
    var dataRecordPatterns = fromSuffixTree(suffixTree);
    var htmlTagPathIdentifierByEncodedHtmlTagPathIdentifier = Curry._1(STEM__Interfaces$SmartcutsMacros.MapEncodedHtmlTagPathIdentifier.fromArray, Belt_Array.mapWithIndex(STEM__Interfaces$SmartcutsMacros.EncodedHtmlTagPathIdentifierSequence.toArray(STEM__Interfaces$SmartcutsMacros.EncodedHtmlTagPathIdentifierSequence.fromText(signal.encodedHtmlTagPathIdentifierString)), function(index, encodedHtmlTagPathIdentifier) {
        return [
            encodedHtmlTagPathIdentifier,
            STEM__Interfaces$SmartcutsMacros.HtmlTagPathIdentifier.fromInt(index)
        ];
    }));
    return {
        suffixTree: suffixTree,
        encodedWebPageSequence: STEM__Interfaces$SmartcutsMacros.EncodedHtmlTagPathIdentifierSequence.fromText(encodedWebPageSequenceString),
        htmlTagPathIdentifierByEncodedHtmlTagPathIdentifier: htmlTagPathIdentifierByEncodedHtmlTagPathIdentifier,
        htmlTagPathIdentifierParentMap: signal.htmlTagPathIdentifierParentMap,
        dataRecordPatterns: dataRecordPatterns
    };
}
function assignFilter(filter, doeSuffixTreeNodeSatisfyFilter1, $$this) {
    forEachValidDataRecordPatterns($$this.dataRecordPatterns, function(substring, dataRecordPattern) {
        if (!Curry._3(doeSuffixTreeNodeSatisfyFilter1, $$this, substring, Curry._1(DataRecordPatterns_DataRecordPattern.getSuffixTreeNode, dataRecordPattern))) {
            return Curry._2(DataRecordPatterns_DataRecordPattern.setIsFilteredBy, dataRecordPattern, filter);
        }
    });
    return $$this;
}
function isAncestorNodeOf($$this, id1, id2) {
    var _id = id2;
    while(true){
        var id = _id;
        var parentId = Belt_Map.get($$this.htmlTagPathIdentifierParentMap, id);
        if (parentId === undefined) {
            return false;
        }
        var parentId$1 = Caml_option.valFromOption(parentId);
        if (Caml_obj.caml_equal(parentId$1, id1)) {
            return true;
        }
        _id = parentId$1;
        continue;
    }
    ;
}
function doeSuffixTreeNodeSatisfyFilter(param, nodeFrequencyEqualsOrGreaterThan, substringLengthEqualsOrGreaterThan, substring, suffixTreeNode) {
    if (substring.length >= substringLengthEqualsOrGreaterThan) {
        return SuffixTree$SmartcutsMacros.$$Node.frequency(param.suffixTree, suffixTreeNode) >= nodeFrequencyEqualsOrGreaterThan;
    } else {
        return false;
    }
}
function apply($$this, nodeFrequencyEqualsOrGreaterThan, substringLengthEqualsOrGreaterThan) {
    var param = {
        TAG: /* ByNodeFrequencyAndEdgeLength */ 0,
        _0: {
            nodeFrequencyEqualsOrGreaterThan: nodeFrequencyEqualsOrGreaterThan,
            substringLengthEqualsOrGreaterThan: substringLengthEqualsOrGreaterThan
        }
    };
    var param$1 = function param$1(param$2) {
        return function(param$3, param$4) {
            return doeSuffixTreeNodeSatisfyFilter(param$2, nodeFrequencyEqualsOrGreaterThan, substringLengthEqualsOrGreaterThan, param$3, param$4);
        };
    };
    return assignFilter(param, param$1, $$this);
}
var ByNodeFrequencyAndEdgeLength = {
    doeSuffixTreeNodeSatisfyFilter: doeSuffixTreeNodeSatisfyFilter,
    apply: apply
};
function findLongestCommonSubstring(s1, s2) {
    var suffixTree = SuffixTree$SmartcutsMacros.makeWithText(s1 + s2);
    var possibleCommonSubstrings = Belt_Array.map(Belt_Array.keep(SuffixTree$SmartcutsMacros.allNodePaths(suffixTree), function(nodePath) {
        return !SuffixTree$SmartcutsMacros.$$Node.isLeaf(SuffixTree$SmartcutsMacros.NodePath.bottom(nodePath));
    }), SuffixTree$SmartcutsMacros.NodePath.collectSubstring);
    return Belt_Array.reduce(possibleCommonSubstrings, undefined, function(maybeLongestCommonSubstring, pattern) {
        if (maybeLongestCommonSubstring !== undefined && maybeLongestCommonSubstring.length >= pattern.length) {
            return maybeLongestCommonSubstring;
        }
        if (s1.indexOf(pattern) > -1 && s2.indexOf(pattern) > -1) {
            return pattern;
        } else {
            return maybeLongestCommonSubstring;
        }
    });
}
function calcRecordValidationRate(candidateSequence, dataRecordPattern) {
    var longestCommonSubstring = findLongestCommonSubstring(dataRecordPattern, candidateSequence);
    if (longestCommonSubstring !== undefined) {
        return longestCommonSubstring.length / dataRecordPattern.length;
    } else {
        return 0;
    }
}
function doeSuffixTreeNodeSatisfyFilter$1(param1, recordValidationRateThreshold, patternValidationRate, substring, suffixTreeNode) {
    var suffixTree = param1.suffixTree;
    var substringLength = substring.length;
    var childNodeAndSubSequences = Belt_Array.map(SuffixTree$SmartcutsMacros.$$Node.childNodes(suffixTree, suffixTreeNode), function(childNode) {
        var subSequence = SuffixTree$SmartcutsMacros.traverse(suffixTree, "", function(node, result) {
            if (result.length >= substringLength) {
                return result;
            }
            var arg = SuffixTree$SmartcutsMacros.$$Node.getText(node);
            var text = function(param) {
                return OptionUtils$SmartcutsMacros.getExn(param, arg);
            }("Expect to get text from node");
            return result + text;
        }, Caml_option.some(childNode), undefined);
        var func = function func(param, param$1) {
            return param$1.slice(0, param);
        };
        return [
            childNode,
            Curry._2(func, substringLength, subSequence)
        ];
    });
    var validChildNodes = Belt_Array.map(Belt_Array.keep(childNodeAndSubSequences, function(param) {
        return calcRecordValidationRate(param[1], substring) >= recordValidationRateThreshold;
    }), function(prim) {
        return prim[0];
    });
    var sumOfAllChildNodesFrequency = Belt_Array.reduce(validChildNodes, 0, function(acc, node) {
        return acc + SuffixTree$SmartcutsMacros.$$Node.frequency(suffixTree, node) | 0;
    });
    return sumOfAllChildNodesFrequency / SuffixTree$SmartcutsMacros.$$Node.frequency(suffixTree, suffixTreeNode) >= patternValidationRate;
}
function apply$1($$this, recordValidationRate, patternValidationRate) {
    var param = {
        TAG: /* ByLongestCommonSubSequence */ 1,
        _0: {
            recordValidationRate: recordValidationRate,
            patternValidationRate: patternValidationRate
        }
    };
    var param$1 = function param$1(param$2) {
        return function(param$3, param$4) {
            return doeSuffixTreeNodeSatisfyFilter$1(param$2, recordValidationRate, patternValidationRate, param$3, param$4);
        };
    };
    return assignFilter(param, param$1, $$this);
}
var ByLongestCommonSubSequence = {
    findLongestCommonSubstring: findLongestCommonSubstring,
    calcRecordValidationRate: calcRecordValidationRate,
    doeSuffixTreeNodeSatisfyFilter: doeSuffixTreeNodeSatisfyFilter$1,
    apply: apply$1
};
function maybeRotateHtmlTagPaths($$this, substring) {
    var htmlTagPathIdentifierSequence = STEM__Interfaces$SmartcutsMacros.EncodedHtmlTagPathIdentifierSequence.decodeToHtmlTagPathIdentifierSequence(STEM__Interfaces$SmartcutsMacros.EncodedHtmlTagPathIdentifierSequence.fromText(substring), $$this.htmlTagPathIdentifierByEncodedHtmlTagPathIdentifier);
    var rootNodeIndex1 = Belt_Array.reduceWithIndex(htmlTagPathIdentifierSequence, 0, function(rootNodeIndex, thisNode, index) {
        var rootNode = Caml_array.get(htmlTagPathIdentifierSequence, rootNodeIndex);
        if (isAncestorNodeOf($$this, thisNode, rootNode) || Caml_obj.caml_equal(thisNode, rootNode)) {
            return index;
        } else {
            return rootNodeIndex;
        }
    });
    if (rootNodeIndex1 === 0) {
        return /* Keep */ 0;
    }
    var htmlTagPathIdentifier = Caml_array.get(htmlTagPathIdentifierSequence, rootNodeIndex1);
    var s0 = Belt_Array.slice(htmlTagPathIdentifierSequence, 0, rootNodeIndex1);
    var arg = Belt_Array.sliceToEnd(htmlTagPathIdentifierSequence, rootNodeIndex1 + 1 | 0);
    var len = function(param) {
        return ArrayUtils$SmartcutsMacros.shortcutWithIndex(param, arg);
    }(function(htmlTagPathIdentifier$p, index) {
        if (STEM__Interfaces$SmartcutsMacros.HtmlTagPathIdentifier.compare(htmlTagPathIdentifier, htmlTagPathIdentifier$p) === 0) {
            return index;
        }
    });
    var htmlTagPathIdentifierSequenceList;
    if (len !== undefined) {
        var s1 = Belt_Array.slice(htmlTagPathIdentifierSequence, rootNodeIndex1, len);
        htmlTagPathIdentifierSequenceList = {
            hd: s1,
            tl: {
                hd: Belt_Array.concat(s1, s0),
                tl: /* [] */ 0
            }
        };
    } else {
        htmlTagPathIdentifierSequenceList = {
            hd: Belt_Array.sliceToEnd(htmlTagPathIdentifierSequence, rootNodeIndex1),
            tl: /* [] */ 0
        };
    }
    return /* ReplaceWith */ {
        _0: htmlTagPathIdentifierSequenceList
    };
}
function apply$2($$this, substringLengthEqualsOrGreaterThan, param) {
    var doesSequenceSatifiesLengthFilter = function doesSequenceSatifiesLengthFilter(htmlTagPathIdentifierSequence) {
        if (substringLengthEqualsOrGreaterThan !== undefined) {
            return htmlTagPathIdentifierSequence.length >= substringLengthEqualsOrGreaterThan;
        } else {
            return true;
        }
    };
    var dataRecordPatterns1 = reduceValidDataRecordPatterns($$this.dataRecordPatterns, $$this.dataRecordPatterns, function(dataRecordPatterns2, substring, dataRecordPattern) {
        var htmlTagPathIdentifierSequenceList = maybeRotateHtmlTagPaths($$this, substring);
        if (htmlTagPathIdentifierSequenceList) {
            return Belt_List.reduce(htmlTagPathIdentifierSequenceList._0, dataRecordPatterns2, function(dataRecordPatterns, htmlTagPathIdentifierSequence) {
                var match = STEM__Interfaces$SmartcutsMacros.EncodedHtmlTagPathIdentifierSequence.encodeFromHtmlTagPathIdentifierSequence(htmlTagPathIdentifierSequence);
                var _$substring = STEM__Interfaces$SmartcutsMacros.EncodedHtmlTagPathIdentifierSequence.makeText(match[0]);
                Curry._2(DataRecordPatterns_DataRecordPattern.setIsFilteredBy, dataRecordPattern, /* ByTreeStructure */ 0);
                var dataRecordPattern$1 = List.assoc_opt(_$substring, $$Array.to_list($$this.dataRecordPatterns));
                if (dataRecordPattern$1 === undefined) {
                    return dataRecordPatterns;
                }
                var dataRecordPattern$2 = Caml_option.valFromOption(dataRecordPattern$1);
                if (!doesSequenceSatifiesLengthFilter(htmlTagPathIdentifierSequence)) {
                    return dataRecordPatterns;
                }
                var _filter = Curry._1(DataRecordPatterns_DataRecordPattern.getIsFilteredBy, dataRecordPattern$2);
                if (_filter !== undefined) {
                    Curry._2(DataRecordPatterns_DataRecordPattern.setIsFilteredBy, dataRecordPattern$2, undefined);
                    return dataRecordPatterns;
                } else {
                    return dataRecordPatterns;
                }
            });
        } else {
            return dataRecordPatterns2;
        }
    });
    return {
        suffixTree: $$this.suffixTree,
        encodedWebPageSequence: $$this.encodedWebPageSequence,
        htmlTagPathIdentifierByEncodedHtmlTagPathIdentifier: $$this.htmlTagPathIdentifierByEncodedHtmlTagPathIdentifier,
        htmlTagPathIdentifierParentMap: $$this.htmlTagPathIdentifierParentMap,
        dataRecordPatterns: dataRecordPatterns1
    };
}
var ByTreeStructure = {
    maybeRotateHtmlTagPaths: maybeRotateHtmlTagPaths,
    apply: apply$2
};
function doeSuffixTreeNodeSatisfyFilter$2($$this, substring, param) {
    return reduceValidDataRecordPatterns($$this.dataRecordPatterns, true, function(previousResult, repeatedSubstring, param) {
        if (previousResult) {
            return !substring.slice(repeatedSubstring.length).startsWith(repeatedSubstring);
        } else {
            return false;
        }
    });
}
function apply$3($$this) {
    return assignFilter(/* ByRepetition */ 1, doeSuffixTreeNodeSatisfyFilter$2, $$this);
}
var ByRepetition = {
    doeSuffixTreeNodeSatisfyFilter: doeSuffixTreeNodeSatisfyFilter$2,
    apply: apply$3
};
var Filters = {
    ByNodeFrequencyAndEdgeLength: ByNodeFrequencyAndEdgeLength,
    ByLongestCommonSubSequence: ByLongestCommonSubSequence,
    ByTreeStructure: ByTreeStructure,
    ByRepetition: ByRepetition
};
function applyFilters($$this1, filters) {
    return Belt_Array.reduce(filters, $$this1, function($$this, filter1) {
        if (typeof filter1 === "number") {
            if (filter1 !== /* ByTreeStructure */ 0) {
                return apply$3($$this);
            }
            var substringLengthEqualsOrGreaterThan = ArrayUtils$SmartcutsMacros.shortcut(function(filter) {
                if (typeof filter === "number" || filter.TAG !== /* ByNodeFrequencyAndEdgeLength */ 0) {
                    return;
                } else {
                    return filter._0.substringLengthEqualsOrGreaterThan;
                }
            }, filters);
            return apply$2($$this, substringLengthEqualsOrGreaterThan, undefined);
        } else {
            if (filter1.TAG === /* ByNodeFrequencyAndEdgeLength */ 0) {
                var match = filter1._0;
                return apply($$this, match.nodeFrequencyEqualsOrGreaterThan, match.substringLengthEqualsOrGreaterThan);
            }
            var match$1 = filter1._0;
            return apply$1($$this, match$1.recordValidationRate, match$1.patternValidationRate);
        }
    });
}
function output($$this) {
    var dataRecordPatternListBySubstring1 = reduceValidDataRecordPatterns($$this.dataRecordPatterns, undefined, function(dataRecordPatternListBySubstring, substring, dataRecordPattern) {
        var dataRecordPatternList = Belt_MapString.get(dataRecordPatternListBySubstring, substring);
        if (dataRecordPatternList !== undefined) {
            return Belt_MapString.set(dataRecordPatternListBySubstring, substring, Belt_List.add(dataRecordPatternList, dataRecordPattern));
        } else {
            return Belt_MapString.set(dataRecordPatternListBySubstring, substring, {
                hd: dataRecordPattern,
                tl: /* [] */ 0
            });
        }
    });
    return {
        uniqueEncodedHtmlTagPathIdentifierStrings: Belt_MapString.keysToArray(dataRecordPatternListBySubstring1)
    };
}
exports.DataRecordPatterns = DataRecordPatterns;
exports.fromSignal = fromSignal;
exports.isAncestorNodeOf = isAncestorNodeOf;
exports.Filters = Filters;
exports.applyFilters = applyFilters;
exports.output = output; /* ArrayUtils-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 28314:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var List = __webpack_require__(68724);
var Belt_List = __webpack_require__(11332);
var Belt_Array = __webpack_require__(2971);
var SuffixTreeJs = __webpack_require__(22604);
var ArrayUtils$SmartcutsMacros = __webpack_require__(6114);
var GenericTree$SmartcutsMacros = __webpack_require__(57165);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
function sliceFrom(endPosition, text, from) {
    if (Number.isFinite(endPosition)) {
        return text.slice(from, endPosition + 1 | 0);
    } else {
        return text.slice(from);
    }
}
function childNodes(suffixTree, node) {
    return Belt_Array.map(Object.entries(node.transition), function(param) {
        var match = param[1];
        return [
            sliceFrom(match[2], suffixTree.text, match[1]),
            match[0]
        ];
    });
}
function makeWithText(text) {
    var suffixTree = new SuffixTreeJs.SuffixTree();
    return suffixTree.addString(text + "$");
}
function isRoot(node) {
    return node === /* Root */ 0;
}
function isLeaf(node) {
    if (node) {
        return node._0.nodeRef.isLeaf();
    } else {
        return false;
    }
}
function getText(node) {
    if (node) {
        return node._0.text;
    }
}
function childNodes$1(suffixTree, node) {
    var nodeRef = node ? node._0.nodeRef : suffixTree.root;
    return Belt_Array.map(childNodes(suffixTree, nodeRef), function(param) {
        return /* Node */ {
            _0: {
                nodeRef: param[1],
                text: param[0],
                parentNode: node
            }
        };
    });
}
function traverse(suffixTree, initResult, combineNodeWithResult, rootNode1) {
    return GenericTree$SmartcutsMacros.depthFirst(function(param) {
        return childNodes$1(suffixTree, param);
    }, initResult, combineNodeWithResult, rootNode1);
}
function frequency(suffixTree, node1) {
    return traverse(suffixTree, 0, function(node, previousResult) {
        if (isLeaf(node)) {
            return 1 + previousResult | 0;
        } else {
            return previousResult;
        }
    }, node1);
}
function traverse$1($$this, initResult, combineNodeWithResult, rootNodeOpt, param) {
    var rootNode2 = rootNodeOpt !== undefined ? rootNodeOpt : /* Root */ 0;
    return traverse($$this, initResult, combineNodeWithResult, rootNode2);
}
function collectSubstring(nodePath) {
    return Belt_List.reduce(nodePath, "", function(text, node) {
        var text$p = getText(node);
        if (text$p !== undefined) {
            return text$p + text;
        } else {
            return text;
        }
    });
}
function bottom(nodePath) {
    return List.nth(nodePath, 0);
}
var add = Belt_List.add;
var NodePath = {
    collectSubstring: collectSubstring,
    bottom: bottom,
    add: add
};
function allNodePaths($$this) {
    var pathForNode = function pathForNode(node, currentPath) {
        if (!node) {
            return [
                currentPath,
                undefined
            ];
        }
        var suffixPath = Belt_List.add(currentPath, node);
        return [
            suffixPath,
            suffixPath
        ];
    };
    var traverse1 = function(state, nodes) {
        return ArrayUtils$SmartcutsMacros.flatMap(function(node) {
            var match = pathForNode(node, state);
            var maybeResult = match[1];
            var childNodes$2 = childNodes$1($$this, node);
            if (childNodes$2.length !== 0) {
                return Belt_Array.concat(OptionUtils$SmartcutsMacros.toArray(maybeResult), traverse1(match[0], childNodes$2));
            } else {
                return OptionUtils$SmartcutsMacros.toArray(maybeResult);
            }
        }, nodes);
    };
    return traverse1(/* [] */ 0, [
        /* Root */ 0
    ]);
}
function allSuffixes($$this) {
    return Belt_Array.map(Belt_Array.keep(allNodePaths($$this), function(nodePath) {
        return isLeaf(List.nth(nodePath, 0));
    }), collectSubstring);
}
var rootNode = /* Root */ 0;
var $$Node = {
    isRoot: isRoot,
    getText: getText,
    isLeaf: isLeaf,
    childNodes: childNodes$1,
    frequency: frequency
};
exports.makeWithText = makeWithText;
exports.rootNode = rootNode;
exports.$$Node = $$Node;
exports.NodePath = NodePath;
exports.traverse = traverse$1;
exports.allNodePaths = allNodePaths;
exports.allSuffixes = allSuffixes; /* ./SuffixTree.js Not a pure module */ 


/***/ }),

/***/ 22604:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SuffixTree": function() { return /* binding */ SuffixTree; }
/* harmony export */ });
/*jshint esnext: true, -W097  */ /* globals console */ 
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var Node = /*#__PURE__*/ function() {
    function Node() {
        _classCallCheck(this, Node);
        this.transition = {};
        this.suffixLink = null;
    }
    _createClass(Node, [
        {
            key: "addTransition",
            value: function addTransition(node, param, t) {
                var _param = _slicedToArray(param, 2), start = _param[0], end = _param[1];
                this.transition[t] = [
                    node,
                    start,
                    end
                ];
            }
        },
        {
            key: "isLeaf",
            value: function isLeaf() {
                return Object.keys(this.transition).length === 0;
            }
        }
    ]);
    return Node;
}();
var SuffixTree = /*#__PURE__*/ function() {
    function SuffixTree() {
        _classCallCheck(this, SuffixTree);
        this.text = "";
        this.root = new Node();
        this.bottom = new Node();
        this.root.suffixLink = this.bottom;
        this.s = this.root;
        this.k = 0;
        this.i = -1;
    }
    _createClass(SuffixTree, [
        {
            key: "addString",
            value: function addString(str) {
                var temp = this.text.length;
                this.text += temp ? "\u2687" + str : str;
                var ref = [
                    this.s,
                    this.k,
                    this.i
                ], s = ref[0], k = ref[1], i = ref[2];
                for(var j = temp; j < this.text.length; j++){
                    this.bottom.addTransition(this.root, [
                        j,
                        j
                    ], this.text[j]);
                }
                while(this.text[i + 1]){
                    i++;
                    var ref1;
                    ref1 = _slicedToArray(this.update(s, [
                        k,
                        i
                    ]), 2), s = ref1[0], k = ref1[1], ref1;
                    var ref2;
                    ref2 = _slicedToArray(this.canonize(s, [
                        k,
                        i
                    ]), 2), s = ref2[0], k = ref2[1], ref2;
                }
                var ref3;
                ref3 = [
                    s,
                    k,
                    i
                ], this.s = ref3[0], this.k = ref3[1], this.i = ref3[2], ref3;
                return this;
            }
        },
        {
            key: "update",
            value: function update(s, param) {
                var _param = _slicedToArray(param, 2), k = _param[0], i = _param[1];
                var oldr = this.root;
                var ref = _slicedToArray(this.testAndSplit(s, [
                    k,
                    i - 1
                ], this.text[i]), 2), endPoint = ref[0], r = ref[1];
                while(!endPoint){
                    r.addTransition(new Node(), [
                        i,
                        Infinity
                    ], this.text[i]);
                    if (oldr != this.root) {
                        oldr.suffixLink = r;
                    }
                    oldr = r;
                    var ref4;
                    ref4 = _slicedToArray(this.canonize(s.suffixLink, [
                        k,
                        i - 1
                    ]), 2), s = ref4[0], k = ref4[1], ref4;
                    var ref5;
                    ref5 = _slicedToArray(this.testAndSplit(s, [
                        k,
                        i - 1
                    ], this.text[i]), 2), endPoint = ref5[0], r = ref5[1], ref5;
                }
                if (oldr != this.root) {
                    oldr.suffixLink = s;
                }
                return [
                    s,
                    k
                ];
            }
        },
        {
            key: "testAndSplit",
            value: function testAndSplit(s, param, t) {
                var _param = _slicedToArray(param, 2), k = _param[0], p = _param[1];
                if (k <= p) {
                    var _k = _slicedToArray(s.transition[this.text[k]], 3), s2 = _k[0], k2 = _k[1], p2 = _k[2];
                    if (t == this.text[k2 + p - k + 1]) {
                        return [
                            true,
                            s
                        ];
                    } else {
                        var r = new Node();
                        s.addTransition(r, [
                            k2,
                            k2 + p - k
                        ], this.text[k2]);
                        r.addTransition(s2, [
                            k2 + p - k + 1,
                            p2
                        ], this.text[k2 + p - k + 1]);
                        return [
                            false,
                            r
                        ];
                    }
                } else {
                    if (!s.transition[t]) return [
                        false,
                        s
                    ];
                    else return [
                        true,
                        s
                    ];
                }
            }
        },
        {
            key: "canonize",
            value: function canonize(s, param) {
                var _param = _slicedToArray(param, 2), k = _param[0], p = _param[1];
                if (p < k) return [
                    s,
                    k
                ];
                else {
                    var _k = _slicedToArray(s.transition[this.text[k]], 3), s2 = _k[0], k2 = _k[1], p2 = _k[2];
                    while(p2 - k2 <= p - k){
                        k = k + p2 - k2 + 1;
                        s = s2;
                        if (k <= p) {
                            var ref;
                            ref = _slicedToArray(s.transition[this.text[k]], 3), s2 = ref[0], k2 = ref[1], p2 = ref[2], ref;
                        }
                    }
                    return [
                        s,
                        k
                    ];
                }
            }
        },
        {
            key: "findLongestRepeatedSubstrings",
            value: function findLongestRepeatedSubstrings() {
                var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 3;
                var ref = [
                    this.text,
                    this.root
                ], text = ref[0], root = ref[1];
                var longestSubstrings = [];
                (function traverse(node) {
                    var curStr = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
                    if (node.isLeaf()) return;
                    for(var t in node.transition){
                        var _t = _slicedToArray(node.transition[t], 3), s = _t[0], a = _t[1], b = _t[2];
                        if (!s.isLeaf()) {
                            var curCurStr = curStr;
                            var curSubStr = text.substring(a, b + 1);
                            curCurStr = node === root ? curSubStr : curCurStr + curSubStr;
                            longestSubstrings.push(curCurStr);
                            traverse(s, curCurStr);
                        }
                    }
                })(root);
                return longestSubstrings.sort(function(a, b) {
                    return b.length - a.length;
                }).slice(0, n);
            }
        },
        {
            key: "toString",
            value: function toString() {
                var text = this.text;
                function traverse(node) {
                    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", ret = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
                    for(var t in node.transition){
                        var _t = _slicedToArray(node.transition[t], 3), s = _t[0], a = _t[1], b = _t[2];
                        ret += offset + '["' + text.substring(a, b + 1) + '", ' + a + ", " + b + "]" + "\r\n";
                        ret += traverse(s, offset + "	");
                    }
                    return ret;
                }
                var res = traverse(this.root);
                return res;
            }
        },
        {
            key: "print",
            value: function print() {
                console.log(this.toString());
            }
        }
    ]);
    return SuffixTree;
}();


/***/ }),

/***/ 43492:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var List = __webpack_require__(68724);
var $$Array = __webpack_require__(53209);
var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Fetch = __webpack_require__(84403);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Caml_obj = __webpack_require__(14923);
var Belt_Array = __webpack_require__(2971);
var Caml_array = __webpack_require__(11748);
var Belt_Option = __webpack_require__(46517);
var Belt_Result = __webpack_require__(86369);
var Caml_option = __webpack_require__(57175);
var Log$SmartcutsMacros = __webpack_require__(78088);
var Util$SmartcutsMacros = __webpack_require__(25092);
var Exceptions$SmartcutsMacros = __webpack_require__(54278);
var JsExnUtils$SmartcutsMacros = __webpack_require__(79713);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var StringUtils$SmartcutsMacros = __webpack_require__(61217);
var PromiseUtils$SmartcutsMacros = __webpack_require__(57019);
var JsPromiseErrorUtils$SmartcutsMacros = __webpack_require__(72349);
function t_encode(v1) {
    return Js_dict.fromArray([
        [
            "message",
            Decco.stringToJson(v1.message)
        ],
        [
            "extensions",
            Decco.dictToJson(function(v) {
                return v;
            }, v1.extensions)
        ]
    ]);
}
function t_decode(v2) {
    var dict = Js_json.classify(v2);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v2);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v2);
    }
    var dict$1 = dict._0;
    var message = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "message"), null));
    if (message.TAG === /* Ok */ 0) {
        var extensions = Decco.dictFromJson(function(v) {
            return {
                TAG: /* Ok */ 0,
                _0: v
            };
        }, Belt_Option.getWithDefault(Js_dict.get(dict$1, "extensions"), null));
        if (extensions.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    message: message._0,
                    extensions: extensions._0
                }
            };
        }
        var e = extensions._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".extensions" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = message._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".message" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
var $$Error = {
    t_encode: t_encode,
    t_decode: t_decode
};
var FaunaResponseBody = {
    $$Error: $$Error
};
function authenticationError_encode(v) {
    return Js_dict.fromArray([
        [
            "status",
            Decco.intToJson(v.status)
        ],
        [
            "bodyText",
            Decco.stringToJson(v.bodyText)
        ]
    ]);
}
function authenticationError_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var status = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "status"), null));
    if (status.TAG === /* Ok */ 0) {
        var bodyText = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "bodyText"), null));
        if (bodyText.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    status: status._0,
                    bodyText: bodyText._0
                }
            };
        }
        var e = bodyText._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".bodyText" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = status._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".status" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function t_encode$1(v) {
    return Js_dict.fromArray([
        [
            "status",
            Decco.intToJson(v.status)
        ],
        [
            "bodyText",
            Decco.stringToJson(v.bodyText)
        ]
    ]);
}
function t_decode$1(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var status = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "status"), null));
    if (status.TAG === /* Ok */ 0) {
        var bodyText = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "bodyText"), null));
        if (bodyText.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    status: status._0,
                    bodyText: bodyText._0
                }
            };
        }
        var e = bodyText._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".bodyText" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = status._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".status" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
var OtherNon2xxError = {
    t_encode: t_encode$1,
    t_decode: t_decode$1
};
function t_encode$2(v) {
    if (typeof v === "number") {
        switch(v){
            case /* PayloadTooLarge */ 0:
                return [
                    "PayloadTooLarge"
                ];
            case /* MissingAuthorizationHeader */ 1:
                return [
                    "MissingAuthorizationHeader"
                ];
            case /* InvalidAuthorizationHeader */ 2:
                return [
                    "InvalidAuthorizationHeader"
                ];
            case /* InvalidDatabaseSecret */ 3:
                return [
                    "InvalidDatabaseSecret"
                ];
            case /* InternalServerError */ 4:
                return [
                    "InternalServerError"
                ];
            case /* ServiceNotAvailable */ 5:
                return [
                    "ServiceNotAvailable"
                ];
        }
    } else {
        switch(v.TAG | 0){
            case /* FailedToFetch */ 0:
                return [
                    "FailedToFetch",
                    JsExnUtils$SmartcutsMacros.t_encode(v._0)
                ];
            case /* AuthenticationError */ 1:
                return [
                    "AuthenticationError",
                    authenticationError_encode(v._0)
                ];
            case /* NoKeyFoundForSecret */ 2:
                return [
                    "NoKeyFoundForSecret",
                    Decco.stringToJson(v._0)
                ];
            case /* JsExnError */ 3:
                return [
                    "JsExnError",
                    JsExnUtils$SmartcutsMacros.t_encode(v._0)
                ];
            case /* OtherJsPromiseError */ 4:
                return [
                    "OtherJsPromiseError",
                    Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.t_encode, v._0)
                ];
            case /* OtherErrors */ 5:
                return [
                    "OtherErrors",
                    Decco.arrayToJson(t_encode, v._0)
                ];
            case /* OtherNon2xxErrors */ 6:
                return [
                    "OtherNon2xxErrors",
                    t_encode$1(v._0)
                ];
            case /* MissingInExpectedJson */ 7:
                return [
                    "MissingInExpectedJson",
                    Decco.arrayToJson(Decco.stringToJson, v._0),
                    v._1
                ];
        }
    }
}
function t_decode$2(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "AuthenticationError":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = authenticationError_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* AuthenticationError */ 1,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "FailedToFetch":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = JsExnUtils$SmartcutsMacros.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* FailedToFetch */ 0,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            case "InternalServerError":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* InternalServerError */ 4
                    };
                }
            case "InvalidAuthorizationHeader":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* InvalidAuthorizationHeader */ 2
                    };
                }
            case "InvalidDatabaseSecret":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* InvalidDatabaseSecret */ 3
                    };
                }
            case "JsExnError":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$2 = JsExnUtils$SmartcutsMacros.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$2.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* JsExnError */ 3,
                            _0: v0$2._0
                        }
                    };
                }
                var e$2 = v0$2._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            case "MissingAuthorizationHeader":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* MissingAuthorizationHeader */ 1
                    };
                }
            case "MissingInExpectedJson":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$1 = Decco.arrayFromJson(Decco.stringFromJson, Belt_Array.getExn(jsonArr$1, 1));
                var match$2 = {
                    TAG: /* Ok */ 0,
                    _0: Belt_Array.getExn(jsonArr$1, 2)
                };
                if (match$1.TAG === /* Ok */ 0) {
                    if (match$2.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* MissingInExpectedJson */ 7,
                                _0: match$1._0,
                                _1: match$2._0
                            }
                        };
                    }
                    var e$3 = match$2._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$3.path,
                            message: e$3.message,
                            value: e$3.value
                        }
                    };
                }
                var e$4 = match$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$4.path,
                        message: e$4.message,
                        value: e$4.value
                    }
                };
            case "NoKeyFoundForSecret":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$3 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$3.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* NoKeyFoundForSecret */ 2,
                            _0: v0$3._0
                        }
                    };
                }
                var e$5 = v0$3._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$5.path,
                        message: e$5.message,
                        value: e$5.value
                    }
                };
            case "OtherErrors":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$4 = Decco.arrayFromJson(t_decode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$4.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* OtherErrors */ 5,
                            _0: v0$4._0
                        }
                    };
                }
                var e$6 = v0$4._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$6.path,
                        message: e$6.message,
                        value: e$6.value
                    }
                };
            case "OtherJsPromiseError":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$5 = Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.t_decode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$5.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* OtherJsPromiseError */ 4,
                            _0: v0$5._0
                        }
                    };
                }
                var e$7 = v0$5._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$7.path,
                        message: e$7.message,
                        value: e$7.value
                    }
                };
            case "OtherNon2xxErrors":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$6 = t_decode$1(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$6.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* OtherNon2xxErrors */ 6,
                            _0: v0$6._0
                        }
                    };
                }
                var e$8 = v0$6._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$8.path,
                        message: e$8.message,
                        value: e$8.value
                    }
                };
            case "PayloadTooLarge":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* PayloadTooLarge */ 0
                    };
                }
            case "ServiceNotAvailable":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* ServiceNotAvailable */ 5
                    };
                }
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function toHumanReadable(error) {
    if (typeof error === "number") {
        switch(error){
            case /* PayloadTooLarge */ 0:
                return "Payload too large";
            case /* MissingAuthorizationHeader */ 1:
                return "Missing Authorization header";
            case /* InvalidAuthorizationHeader */ 2:
                return "Invalid Authorization header";
            case /* InvalidDatabaseSecret */ 3:
                return "Invalid Database Secret";
            case /* InternalServerError */ 4:
                return "Internal Server Error";
            case /* ServiceNotAvailable */ 5:
                return "Service Not Available";
        }
    } else {
        switch(error.TAG | 0){
            case /* FailedToFetch */ 0:
                var arg = error._0.message;
                return "Failed to fetch: " + function(param) {
                    return OptionUtils$SmartcutsMacros.withDefault(param, arg);
                }("An error occurred");
            case /* AuthenticationError */ 1:
                var match = error._0;
                return "Authentication error (" + (String(match.status) + (": " + match.bodyText));
            case /* NoKeyFoundForSecret */ 2:
                return "No key found for secret";
            case /* JsExnError */ 3:
                var arg$1 = error._0.message;
                var param1 = "An error occurred";
                return OptionUtils$SmartcutsMacros.withDefault(param1, arg$1);
            case /* OtherJsPromiseError */ 4:
                return "An error occurred during the promise";
            case /* OtherErrors */ 5:
                return Belt_Array.reduceWithIndex(error._0, "Other errors: ", function(cumulativeMsg, param, index) {
                    return cumulativeMsg + ((index === 0 ? "" : "; ") + param.message);
                });
            case /* OtherNon2xxErrors */ 6:
                var match$1 = error._0;
                return String(match$1.status) + (" error: " + match$1.bodyText);
            case /* MissingInExpectedJson */ 7:
                return "Missing " + (error._0.join(".") + (" in " + JSON.stringify(error._1)));
        }
    }
}
function fromApolloClientError(apolloError) {
    var networkError = apolloError.networkError;
    var graphQLErrors = apolloError.graphQLErrors;
    if (Belt_Array.some(graphQLErrors, function(err) {
        return err.message.startsWith("Missing authorization header");
    })) {
        return /* MissingAuthorizationHeader */ 1;
    }
    if (Belt_Array.some(graphQLErrors, function(err) {
        return err.message.startsWith("Invalid authorization header");
    })) {
        return /* InvalidAuthorizationHeader */ 2;
    }
    if (Belt_Array.some(graphQLErrors, function(err) {
        return err.message.startsWith("Invalid database secret");
    })) {
        return /* InvalidDatabaseSecret */ 3;
    }
    if (networkError === undefined) {
        return {
            TAG: /* OtherErrors */ 5,
            _0: []
        };
    }
    switch(networkError.TAG | 0){
        case /* FetchFailure */ 0:
            var jsExn = networkError._0;
            var msg = jsExn.message;
            if (msg !== undefined) {
                if (msg.startsWith("Missing authorization header")) {
                    return /* MissingAuthorizationHeader */ 1;
                } else if (msg.startsWith("Invalid authorization header")) {
                    return /* InvalidAuthorizationHeader */ 2;
                } else if (msg.startsWith("Invalid database secret")) {
                    return /* InvalidDatabaseSecret */ 3;
                } else {
                    return {
                        TAG: /* FailedToFetch */ 0,
                        _0: jsExn
                    };
                }
            } else {
                return {
                    TAG: /* FailedToFetch */ 0,
                    _0: jsExn
                };
            }
        case /* BadStatus */ 1:
            var status = networkError._0;
            if (status !== 401) {
                if (status !== 413) {
                    return {
                        TAG: /* OtherNon2xxErrors */ 6,
                        _0: {
                            status: status,
                            bodyText: ""
                        }
                    };
                } else {
                    console.warn("Graphql payload too large. Make sure the payload is less than 1,020 kb");
                    return /* PayloadTooLarge */ 0;
                }
            }
            var message = networkError._1.message;
            if (message.startsWith("Missing authorization header")) {
                return /* MissingAuthorizationHeader */ 1;
            } else if (message.startsWith("Invalid authorization header")) {
                return /* InvalidAuthorizationHeader */ 2;
            } else if (message.startsWith("Invalid database secret")) {
                return /* InvalidDatabaseSecret */ 3;
            } else {
                return {
                    TAG: /* AuthenticationError */ 1,
                    _0: {
                        status: 401,
                        bodyText: ""
                    }
                };
            }
        case /* BadBody */ 2:
        case /* ParseError */ 3:
            return {
                TAG: /* OtherErrors */ 5,
                _0: []
            };
    }
}
function consoleError(error) {
    if (typeof error === "number") {
        switch(error){
            case /* PayloadTooLarge */ 0:
                console.error("Payload too large");
                return;
            case /* MissingAuthorizationHeader */ 1:
                console.error("Missing Authorization header");
                return;
            case /* InvalidAuthorizationHeader */ 2:
                console.error("Invalid Authorization header");
                return;
            case /* InvalidDatabaseSecret */ 3:
                console.error("Invalid Database Secret");
                return;
            case /* InternalServerError */ 4:
                console.error("Internal Server Error");
                return;
            case /* ServiceNotAvailable */ 5:
                console.error("Service Not Available");
                return;
        }
    } else {
        switch(error.TAG | 0){
            case /* AuthenticationError */ 1:
                var match = error._0;
                console.error("Authentication error", match.status, match.bodyText);
                return;
            case /* NoKeyFoundForSecret */ 2:
                console.error("No key found for secret");
                return;
            case /* OtherErrors */ 5:
                return Belt_Array.forEach(error._0, function(param) {
                    console.error("Other error", param.message, param.extensions);
                });
            case /* OtherNon2xxErrors */ 6:
                console.error("Other non-2xx error", JSON.stringify(error._0));
                return;
            case /* MissingInExpectedJson */ 7:
                var json = error._1;
                console.error("Missing " + (error._0.join(".") + (" in " + JSON.stringify(json))), json);
                return;
            default:
                console.error(error._0);
                return;
        }
    }
}
function isAuthIssue(error) {
    if (typeof error === "number") {
        switch(error){
            case /* MissingAuthorizationHeader */ 1:
            case /* InvalidAuthorizationHeader */ 2:
            case /* InvalidDatabaseSecret */ 3:
                return true;
            default:
                return false;
        }
    } else {
        switch(error.TAG | 0){
            case /* AuthenticationError */ 1:
            case /* NoKeyFoundForSecret */ 2:
                return true;
            default:
                return false;
        }
    }
}
function handleWithRaise(error1, context) {
    if (typeof error1 === "number") {
        switch(error1){
            case /* PayloadTooLarge */ 0:
                return Util$SmartcutsMacros.logAndRaiseJsError("Payload too large when " + context);
            case /* MissingAuthorizationHeader */ 1:
                return Util$SmartcutsMacros.logAndRaiseJsError("Missing Authorization header when " + context);
            case /* InvalidAuthorizationHeader */ 2:
                return Util$SmartcutsMacros.logAndRaiseJsError("Invalid Authorization header when " + context);
            case /* InvalidDatabaseSecret */ 3:
                return Util$SmartcutsMacros.logAndRaiseJsError("Invalid secret when " + context);
            case /* InternalServerError */ 4:
                throw {
                    RE_EXN_ID: Exceptions$SmartcutsMacros.FaunaGraphql.Internal_server_error,
                    Error: new Error()
                };
            case /* ServiceNotAvailable */ 5:
                throw {
                    RE_EXN_ID: Exceptions$SmartcutsMacros.FaunaGraphql.Service_not_available,
                    Error: new Error()
                };
        }
    } else {
        switch(error1.TAG | 0){
            case /* FailedToFetch */ 0:
                console.error("Failed to fetch", error1._0);
                return Util$SmartcutsMacros.logAndRaiseJsError("Failed to fetch from db when " + context);
            case /* AuthenticationError */ 1:
                console.error("Auth error", error1._0);
                return Util$SmartcutsMacros.logAndRaiseJsError("Auth error when " + context);
            case /* NoKeyFoundForSecret */ 2:
                return Util$SmartcutsMacros.logAndRaiseJsError("No key found for secret when " + context);
            case /* JsExnError */ 3:
            case /* OtherJsPromiseError */ 4:
                console.error(error1._0);
                return Util$SmartcutsMacros.logAndRaiseJsError("Encountered an error when " + context);
            case /* OtherErrors */ 5:
                return Util$SmartcutsMacros.logAndRaiseJsError("Faunadb returned errors when " + (context + (": " + StringUtils$SmartcutsMacros.join(", ", $$Array.to_list(Belt_Array.map(error1._0, function(error) {
                    return JSON.stringify(error);
                }))))));
            case /* OtherNon2xxErrors */ 6:
                return Util$SmartcutsMacros.logAndRaiseJsError("Faunadb returned errors: " + JSON.stringify(error1._0));
            case /* MissingInExpectedJson */ 7:
                return Util$SmartcutsMacros.logAndRaiseJsError("Failed to save some command log entries because missing " + (error1._0.join(".") + (" in " + (JSON.stringify(error1._1) + (" when " + context)))));
        }
    }
}
var FaunaGraphqlError = {
    authenticationError_encode: authenticationError_encode,
    authenticationError_decode: authenticationError_decode,
    OtherNon2xxError: OtherNon2xxError,
    t_encode: t_encode$2,
    t_decode: t_decode$2,
    toHumanReadable: toHumanReadable,
    fromApolloClientError: fromApolloClientError,
    consoleError: consoleError,
    isAuthIssue: isAuthIssue,
    handleWithRaise: handleWithRaise
};
function raiseIfError(result, context) {
    if (result.TAG === /* Ok */ 0) {
        return result;
    } else {
        return handleWithRaise(result._0, context);
    }
}
var FaunaGraphqlResult = {
    raiseIfError: raiseIfError
};
function sendGraphqlQueryExn(token, queryString, maybeVariables, parse, param3) {
    var arg1 = OptionUtils$SmartcutsMacros.map(maybeVariables, function(variables) {
        return {
            hd: [
                "variables",
                variables
            ],
            tl: /* [] */ 0
        };
    });
    return fetch("https://graphql.fauna.com/graphql", Fetch.RequestInit.make(/* Post */ 2, {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
        "X-Schema-Preview": "partial-update-mutation"
    }, Caml_option.some(JSON.stringify(Js_dict.fromList(List.append({
        hd: [
            "query",
            queryString
        ],
        tl: /* [] */ 0
    }, function(param) {
        return OptionUtils$SmartcutsMacros.withDefault(param, arg1);
    }(/* [] */ 0))))), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)(undefined)).then(function(res) {
        var status = res.status;
        if (status !== 401) {
            if (status !== 413) {
                if (status >= 200 && status < 300) {
                    return res.json().then(function(json) {
                        var errors = json.errors;
                        var data = json.data;
                        var tmp;
                        if (data == null) {
                            if (errors !== undefined) {
                                if (errors.length !== 1) {
                                    tmp = {
                                        TAG: /* Error */ 1,
                                        _0: {
                                            TAG: /* OtherErrors */ 5,
                                            _0: errors
                                        }
                                    };
                                } else {
                                    var match = errors[0];
                                    var message = match.message;
                                    switch(message){
                                        case "An internal server error occurred. Please contact Fauna support.":
                                            tmp = {
                                                TAG: /* Error */ 1,
                                                _0: /* InternalServerError */ 4
                                            };
                                            break;
                                        case "Invalid authorization header":
                                        case "Invalid authorization header.":
                                            tmp = {
                                                TAG: /* Error */ 1,
                                                _0: /* InvalidAuthorizationHeader */ 2
                                            };
                                            break;
                                        case "Invalid database secret":
                                        case "Invalid database secret.":
                                            tmp = {
                                                TAG: /* Error */ 1,
                                                _0: /* InvalidDatabaseSecret */ 3
                                            };
                                            break;
                                        case "Missing authorization header":
                                        case "Missing authorization header.":
                                            tmp = {
                                                TAG: /* Error */ 1,
                                                _0: /* MissingAuthorizationHeader */ 1
                                            };
                                            break;
                                        case "The service is currently unavailable":
                                        case "The service is currently unavailable.":
                                            tmp = {
                                                TAG: /* Error */ 1,
                                                _0: /* ServiceNotAvailable */ 5
                                            };
                                            break;
                                        default:
                                            if (message.startsWith("No key found for secret ")) {
                                                var messageRe = /No key found for secret (.+)\./;
                                                var result = messageRe.exec(message);
                                                var arg = result !== null ? Caml_option.nullable_to_opt(Caml_array.get(result, 1)) : undefined;
                                                var secret = function(param) {
                                                    return OptionUtils$SmartcutsMacros.withDefault(param, arg);
                                                }("<unkown_token>");
                                                tmp = {
                                                    TAG: /* Error */ 1,
                                                    _0: {
                                                        TAG: /* NoKeyFoundForSecret */ 2,
                                                        _0: secret
                                                    }
                                                };
                                            } else {
                                                tmp = {
                                                    TAG: /* Error */ 1,
                                                    _0: {
                                                        TAG: /* OtherErrors */ 5,
                                                        _0: errors
                                                    }
                                                };
                                            }
                                    }
                                }
                            } else {
                                tmp = Util$SmartcutsMacros.logAndRaiseJsError("Expect faunadb response to have at least data or errors");
                            }
                        } else if (errors !== undefined) {
                            Curry._2(Log$SmartcutsMacros.fauna.log2, "data", data);
                            Curry._2(Log$SmartcutsMacros.fauna.error2, "error", errors);
                            tmp = Util$SmartcutsMacros.logAndRaiseJsError("Faunadb response cannot have both data and errors");
                        } else {
                            tmp = {
                                TAG: /* Ok */ 0,
                                _0: Curry._1(parse, data)
                            };
                        }
                        return Promise.resolve(tmp);
                    });
                } else {
                    return res.text().then(function(bodyText) {
                        return Promise.resolve({
                            TAG: /* Error */ 1,
                            _0: {
                                TAG: /* OtherNon2xxErrors */ 6,
                                _0: {
                                    status: status,
                                    bodyText: bodyText
                                }
                            }
                        });
                    });
                }
            } else {
                console.warn("Graphql payload too large. Make sure the payload is less than 1,020 kb");
                return Promise.resolve({
                    TAG: /* Error */ 1,
                    _0: /* PayloadTooLarge */ 0
                });
            }
        } else {
            return res.json().then(function(json) {
                var errors = json.errors;
                if (errors === undefined) {
                    return res.text().then(function(bodyText) {
                        return Promise.resolve({
                            TAG: /* Error */ 1,
                            _0: {
                                TAG: /* AuthenticationError */ 1,
                                _0: {
                                    status: status,
                                    bodyText: bodyText
                                }
                            }
                        });
                    });
                }
                var match = $$Array.to_list(errors);
                var tmp;
                if (match) {
                    switch(match.hd.message){
                        case "Invalid authorization header":
                            tmp = match.tl ? {
                                TAG: /* Error */ 1,
                                _0: {
                                    TAG: /* OtherErrors */ 5,
                                    _0: errors
                                }
                            } : {
                                TAG: /* Error */ 1,
                                _0: /* InvalidAuthorizationHeader */ 2
                            };
                            break;
                        case "Invalid database secret":
                            tmp = match.tl ? {
                                TAG: /* Error */ 1,
                                _0: {
                                    TAG: /* OtherErrors */ 5,
                                    _0: errors
                                }
                            } : {
                                TAG: /* Error */ 1,
                                _0: /* InvalidDatabaseSecret */ 3
                            };
                            break;
                        case "Missing authorization header":
                            tmp = match.tl ? {
                                TAG: /* Error */ 1,
                                _0: {
                                    TAG: /* OtherErrors */ 5,
                                    _0: errors
                                }
                            } : {
                                TAG: /* Error */ 1,
                                _0: /* MissingAuthorizationHeader */ 1
                            };
                            break;
                        default:
                            tmp = {
                                TAG: /* Error */ 1,
                                _0: {
                                    TAG: /* OtherErrors */ 5,
                                    _0: errors
                                }
                            };
                    }
                } else {
                    tmp = {
                        TAG: /* Error */ 1,
                        _0: {
                            TAG: /* OtherErrors */ 5,
                            _0: errors
                        }
                    };
                }
                return Promise.resolve(tmp);
            });
        }
    });
}
function maybeNetworkFailure(error) {
    var jsExn = Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.getErrorType, error);
    if (typeof jsExn === "number") {
        return;
    }
    if (jsExn.TAG !== /* JsExn */ 0) {
        return;
    }
    var jsExn$1 = jsExn._0;
    if (Caml_obj.caml_equal(jsExn$1.name, "TypeError") && Caml_obj.caml_equal(jsExn$1.message, "Failed to fetch")) {
        return Caml_option.some(jsExn$1);
    }
}
function maybeAuthFailure(error) {
    var jsExn = Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.getErrorType, error);
    if (typeof jsExn === "number") {
        return;
    }
    if (jsExn.TAG !== /* JsExn */ 0) {
        return;
    }
    var jsExn$1 = jsExn._0;
    var message = jsExn$1.message;
    if (message !== undefined && message.startsWith("No key found for secret")) {
        return Caml_option.some(jsExn$1);
    }
}
function sendGraphqlQuery(token, queryString, variables, parse, param) {
    return sendGraphqlQueryExn(token, queryString, variables, parse, undefined).catch(function(error) {
        var jsExn = maybeNetworkFailure(error);
        if (jsExn !== undefined) {
            console.warn("No internet connection");
            console.error(error);
            return Promise.resolve({
                TAG: /* Error */ 1,
                _0: {
                    TAG: /* FailedToFetch */ 0,
                    _0: Caml_option.valFromOption(jsExn)
                }
            });
        }
        var _jsExn = maybeAuthFailure(error);
        if (_jsExn !== undefined) {
            return Promise.resolve({
                TAG: /* Error */ 1,
                _0: /* InvalidDatabaseSecret */ 3
            });
        } else {
            console.error(error);
            return Promise.resolve({
                TAG: /* Error */ 1,
                _0: {
                    TAG: /* OtherJsPromiseError */ 4,
                    _0: error
                }
            });
        }
    });
}
function shouldRetryForJsPromiseError(error) {
    var _jsExn = maybeNetworkFailure(error);
    if (_jsExn !== undefined) {
        return true;
    }
    var match = Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.getErrorType, error);
    if (typeof match === "number") {
        return match >= 3;
    } else {
        return false;
    }
}
function sendGraphqlQueryAndRetryIfNetworkError(retriesOpt, token, queryString, variables, parse, param) {
    var retries = retriesOpt !== undefined ? retriesOpt : 3;
    var match1 = PromiseUtils$SmartcutsMacros.withRetries(retries, function(param, param$1) {
        return sendGraphqlQueryExn(token, queryString, variables, parse, undefined).then(function(result) {
            if (result.TAG === /* Ok */ 0) {
                return Promise.resolve(result);
            }
            var match = result._0;
            if (typeof match === "number") {
                if (match !== 4) {
                    if (match >= 5) {
                        return Promise.reject({
                            RE_EXN_ID: Exceptions$SmartcutsMacros.FaunaGraphql.Service_not_available
                        });
                    } else {
                        return Promise.resolve(result);
                    }
                } else {
                    return Promise.reject({
                        RE_EXN_ID: Exceptions$SmartcutsMacros.FaunaGraphql.Internal_server_error
                    });
                }
            } else {
                return Promise.resolve(result);
            }
        });
    }, shouldRetryForJsPromiseError, undefined, undefined);
    var doPromise = match1[0];
    return [
        function(param) {
            return Curry._1(doPromise, undefined).catch(function(error) {
                var _jsExn = maybeAuthFailure(error);
                if (_jsExn !== undefined) {
                    return Promise.resolve({
                        TAG: /* Error */ 1,
                        _0: /* InvalidDatabaseSecret */ 3
                    });
                } else {
                    console.error(error);
                    return Promise.resolve({
                        TAG: /* Error */ 1,
                        _0: {
                            TAG: /* OtherJsPromiseError */ 4,
                            _0: error
                        }
                    });
                }
            });
        },
        match1[1]
    ];
}
function fetchAllInner(client, pageSize, maybeCursor, doSinglePageQuery, outputDataAndMaybeCursorFromQueryResultData) {
    return Curry._3(doSinglePageQuery, client, pageSize, maybeCursor).then(function(result1) {
        if (result1.TAG !== /* Ok */ 0) {
            return Promise.resolve({
                TAG: /* Error */ 1,
                _0: fromApolloClientError(result1._0)
            });
        }
        var match = Curry._1(outputDataAndMaybeCursorFromQueryResultData, result1._0);
        var _$maybeCursor = match[1];
        var data = match[0];
        if (_$maybeCursor !== undefined && data.length === pageSize) {
            return fetchAllInner(client, pageSize, _$maybeCursor, doSinglePageQuery, outputDataAndMaybeCursorFromQueryResultData).then(function(result) {
                return Promise.resolve(Belt_Result.map(result, function(dataNextPage) {
                    return $$Array.append(data, dataNextPage);
                }));
            });
        } else {
            return Promise.resolve({
                TAG: /* Ok */ 0,
                _0: data
            });
        }
    });
}
function fetchAll(client, pageSize, doSinglePageQuery, outputDataAndMaybeCursorFromQueryResultData) {
    return fetchAllInner(client, pageSize, undefined, doSinglePageQuery, outputDataAndMaybeCursorFromQueryResultData);
}
exports.FaunaResponseBody = FaunaResponseBody;
exports.FaunaGraphqlError = FaunaGraphqlError;
exports.FaunaGraphqlResult = FaunaGraphqlResult;
exports.sendGraphqlQueryExn = sendGraphqlQueryExn;
exports.maybeNetworkFailure = maybeNetworkFailure;
exports.maybeAuthFailure = maybeAuthFailure;
exports.sendGraphqlQuery = sendGraphqlQuery;
exports.shouldRetryForJsPromiseError = shouldRetryForJsPromiseError;
exports.sendGraphqlQueryAndRetryIfNetworkError = sendGraphqlQueryAndRetryIfNetworkError;
exports.fetchAllInner = fetchAllInner;
exports.fetchAll = fetchAll; /* Log-SmartcutsMacros Not a pure module */ 


/***/ })

}]);